import { render, staticRenderFns } from "./TheNavbar.vue?vue&type=template&id=80cabe1a&"
import script from "./TheNavbar.vue?vue&type=script&lang=js&"
export * from "./TheNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports